import View from '@shared/components/layout-default/layout-default-router-view';

export const time_conditions = {
  path: 'time-conditions',
  component: View,
  children: [
    {
      path: '',
      name: 'pbx.time-condition.index',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-time-conditions' */
          '@pbx/pages/time-conditions/list'
        ),
      meta: {
        title: { code: 'pbx.breadcrumb.time-condition.index' }
      }
    },

    {
      path: 'new',
      name: 'pbx.time-condition.create',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-time-conditions' */
          '@pbx/pages/time-conditions/form'
        ),
      meta: {
        title: { code: 'pbx.breadcrumb.time-condition.create' }
      }
    },

    {
      path: ':id([\\d]*)',
      name: 'pbx.time-condition.edit',
      component: () =>
        import(
          /* webpackChunkName: 'pbx-time-conditions' */
          '@pbx/pages/time-conditions/form'
        ),
      meta: {
        title: {
          code: 'pbx.breadcrumb.time-condition.edit'
        },
        loadable: true
      }
    }
  ]
};
